const setCurrentAccount = (state, payload) => {
  state.currentAccount = {
    ...payload,
  }
}
export default {
  setCurrentAccount,
}
